export interface LogData {
  id: string;
  title: string;
  date: string;
  author: string;
  url: string;
  content?: string;
}

export const logData: { [key: string]: LogData } = {
  'prologue': {
    id: 'log-00',
    title: 'prologue',
    date: '2018年8月1日',
    author: 'somunia',
    url: 'https://youtu.be/3Rhw8VrA9fE',
    content: `はじめて投稿された映像記録。ビデオカメラを手に入れたことをきっかけに、自分のことを忘れないよう、記録として残すために撮影を開始。以降、少しずつ自身の映像をYouTubeに投稿していくようになる。`
  },
  '#01 me': {
    id: 'log-01',
    title: '#01 me',
    date: '2019年1月6日',
    author: 'somunia',
    url: 'https://youtu.be/cqN7KFqaS8U',
    content: `自身についての基本的な情報を記録した映像。
名前の由来や生活環境、好きなことなどが語られている。`
  },
  '#02 routine': {
    id: 'log-02',
    title: '#02 routine',
    date: '2020年11月13日',
    author: 'somunia',
    url: 'https://youtu.be/K8sK8kOS7uc',
    content: `1日の過ごし方について記録した映像。
起床から就寝までの流れや、普段どのように過ごしているかが語られている。`
  },
  '#03 room': {
    id: 'log-03',
    title: '#03 room',
    date: '2020年12月11日',
    author: 'somunia',
    url: 'https://youtu.be/_xXseE1ySjU',
    content: `自身が過ごす部屋について記録された映像。
空間の特徴や、部屋に置かれているものについて語られている。`
  },
  '#04 test': {
    id: 'log-04',
    title: '#04 test',
    date: '2020年12月12日',
    author: '███',
    url: 'https://youtu.be/VkLcef6JrCE',
    content: `転送装置 使用1回目。
ビデオカメラで街の様子を撮影。`
  },
  '#05 sing in your world': {
    id: 'log-05',
    title: '#05 sing in your world',
    date: '2020年12月14日',
    author: '███',
    url: 'https://youtube.com/live/w1johwdXa3E',
    content: `転送装置 使用2回目。
とある屋上にてミニライブを実施。`
  },
  '# -01 she': {
    id: 'log-06',
    title: '# -01 she',
    date: '2020年12月11日',
    author: '███',
    url: 'https://youtu.be/6e96bGiy2_w',
    content: `███████████████`
  },
  '映像記録_1': {
    id: 'log-07',
    title: '映像記録「不明なソフトによる転移事象」',
    date: '2023年8月31日',
    author: '███',
    url: 'https://youtu.be/GAKmb2mK4x4',
    content: `2023年8月31日に YouTube 上で配信された「somunia 5周年記念配信」より、該当箇所を記録。
配信内、somunia が不明なソフトウェアを起動した直後、画面にノイズが走り、暗転。その後、somunia が「No.248」と呼ばれる空間へ転移している様子が映し出された。`
  },
  'education_video.mp4': {
    id: 'log-08',
    title: 'education_video.mp4',
    date: '██████',
    author: '███',
    url: 'https://youtu.be/ws6uIngX88Y'
  }
}; 